import PartnerContainer from 'containers/PartnerContainer';
import WrapperLayout from 'layouts/WrapperLayout';
import { useTranslation } from 'react-i18next';

type Props = {};

export default function PartnerPage({}: Props) {
  const { t } = useTranslation();

  return (
    <WrapperLayout title={t('title.partner')}>
      <PartnerContainer />
    </WrapperLayout>
  );
}
